module.exports = __webpack_public_path__ + "static/media/save.a2b6bc9b.svg";